import { PiHouseLineBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { Button, Text, Title } from "rizzui";

// images and icons
import NotFoundImg from "@public/not-found.png";

export default function NotFoundPage() {
    const navigate = useNavigate();
    return (
        <div className="flex grow items-center px-6 xl:px-10">
            <div className="mx-auto text-center">
                <img
                    src={NotFoundImg}
                    alt="not found"
                    className="mx-auto mb-8 aspect-[360/326] max-w-[256px] xs:max-w-[370px] lg:mb-12 2xl:mb-16"
                />
                <Title
                    as="h1"
                    className="text-[22px] font-bold leading-normal text-gray-1000 lg:text-3xl"
                >
                    Sorry, the page not found
                </Title>
                <Text className="mt-3 text-sm leading-loose text-gray-500 lg:mt-6 lg:text-base lg:leading-loose">
                    The page you are looking for might have been removed or is
                    under construction,
                    <br className="hidden sm:inline-block" />
                    had it's name changed, or is temporarily unavailable.
                </Text>
                <Button
                    color="primary"
                    size="xl"
                    className="mt-8 h-12 px-4 xl:h-14 xl:px-6"
                    onClick={() => navigate("/")}
                >
                    <PiHouseLineBold className="mr-1.5 text-lg" />
                    Back to home
                </Button>
            </div>
        </div>
    );
}
